import '@stoplight/elements-dev-portal/styles.min.css'

import { FunctionComponent } from 'react'
import { NEXUS_API_SLUG } from 'src/constants'
import { StoplightProject } from '@stoplight/elements-dev-portal'

const NexusAPIV2Docs: FunctionComponent = () => {
  return (
    <>
      <StoplightProject
        basePath={NEXUS_API_SLUG}
        projectId={process.env.REACT_APP_STOPLIGHT_NEXUS_API_V2_ID || ''}
      />
    </>
  )
}

export default NexusAPIV2Docs
